<template>
    <div>
        <limitless-page-header :title="'Tidrapportering'"></limitless-page-header>

        <div class="content">
            <div class="card card-body">
                <time-care-form :id="user.id"></time-care-form>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import TimeCareForm from '@app/pages/users/partials/TimeCareForm';
import { mapState } from 'pinia';
import { useAuthStore } from '@services/pinia/AuthStore';

export default {
    name: 'MyTimecare',
    components: {
        LimitlessPageHeader,
        TimeCareForm,
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
    },
};
</script>
